import { IpadConfigDetails } from '@/features/ipad-configs/components';

const IpadConfigurationDetailsPage = () => {
  return <IpadConfigDetails />;
};

export default IpadConfigurationDetailsPage;
